import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative min-h-[600px] md:min-h-[720px] flex items-center bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10 py-16 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
          <div>
            <span className="inline-block bg-accent-500 text-background-50 text-xs font-medium px-3 py-1.5 rounded-full mb-4 animate-fade-in">
              Temizlikte kalite, hizmette güven
            </span>
            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-4 animate-fade-up">
              Adana'da profesyonel temizlik ve yönetim çözümleri
            </h1>
            <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-8 max-w-2xl animate-fade-up" style={{ animationDelay: "0.1s" }}>
              Day Temizlik Adana olarak dairelerden apartmanlara, site ortak alanlarından inşaat sonrası temizliğe kadar yaşam alanlarınız için güvenilir, düzenli ve hijyen odaklı çözümler sunuyoruz.
            </p>

            <div className="flex flex-col sm:flex-row gap-3 mb-10 animate-fade-up" style={{ animationDelay: "0.2s" }}>
              <Link
                to="/iletisim"
                className="inline-flex items-center justify-center gap-2 bg-primary-500 text-background-50 px-6 py-3.5 rounded-md text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                <i className="ri-calendar-line w-4 h-4 flex items-center justify-center"></i>
                Hemen randevu alın
              </Link>
              <Link
                to="/hizmetlerimiz"
                className="inline-flex items-center justify-center gap-2 bg-background-100 text-foreground-700 border border-background-300/60 px-6 py-3.5 rounded-md text-sm font-medium hover:bg-background-200 transition-colors whitespace-nowrap"
              >
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                Hizmetleri inceleyin
              </Link>
            </div>

            <div className="flex flex-wrap gap-3 md:gap-5 animate-fade-up" style={{ animationDelay: "0.3s" }}>
              {[
                { icon: "ri-shield-check-line", text: "Güvenilir hizmet" },
                { icon: "ri-team-line", text: "Uzman ekip" },
                { icon: "ri-time-line", text: "Zamanında hizmet" },
                { icon: "ri-award-line", text: "Kaliteli çözümler" },
                { icon: "ri-emotion-happy-line", text: "Müşteri memnuniyeti" },
              ].map((item) => (
                <div key={item.text} className="flex items-center gap-1.5 text-foreground-600 text-xs md:text-sm">
                  <i className={`${item.icon} w-4 h-4 flex items-center justify-center text-accent-500`}></i>
                  <span>{item.text}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="grid grid-cols-2 gap-3 md:gap-4">
            <img
              src="/assets/images/hero-temizlik.jpg"
              alt="Day Temizlik Adana profesyonel temizlik hizmeti"
              className="w-full h-48 md:h-72 object-cover rounded-lg"
            />
            <img
              src="/assets/images/home-hero-secondary.jpg"
              alt="Day Temizlik Adana hijyenik yaşam alanları"
              className="w-full h-48 md:h-72 object-cover rounded-lg mt-6 md:mt-8"
            />
          </div>
        </div>
      </div>
    </section>
  );
}